import React from 'react';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { AppBar, MenuItem, IconMenu, IconButton} from 'material-ui';
import {LOGIN} from '../routes';

const styles = {
	logo: {
		display: 'block',
		width: 150,
		height: 150,
		margin: '16px auto',
	}
}

const Logged = ({logout, history}) => (
	<IconMenu
		iconButtonElement={
		<IconButton><MoreVertIcon /></IconButton>
		}
		targetOrigin={{horizontal: 'right', vertical: 'top'}}
		anchorOrigin={{horizontal: 'right', vertical: 'top'}}
	>
		<MenuItem primaryText="Log Out" onTouchTap={() => {
			logout()
			history.push(LOGIN)
		}}/>
	</IconMenu>
);

class MyAppBar extends React.Component {
	
	render() {
		const title = "WMSU BAC System";
		return (
			<div>
			<AppBar
				title={title}
				iconElementLeft={<div></div>}
				iconElementRight={<Logged history={this.props.history} logout={this.props.logout} />}
			/>
			</div>
		)
	}
}

export default MyAppBar


// WEBPACK FOOTER //
// ./src/components/MyAppBar.js